import { render } from "./CustomValidate.vue?vue&type=template&id=6d2ac588&ts=true"
import script from "./CustomValidate.vue?vue&type=script&lang=ts"
export * from "./CustomValidate.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"shared/src/entidades/builder/form/infrastructure/controls/shared/CustomValidate.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6d2ac588"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6d2ac588', __exports__)) {
    api.reload('6d2ac588', __exports__)
  }
  
  module.hot.accept("./CustomValidate.vue?vue&type=template&id=6d2ac588&ts=true", () => {
    api.rerender('6d2ac588', render)
  })

}


export default __exports__